import Service from "../../components/Service/Service";

const Included = () => {
  return (
    <div className="container background_gradient-top">
      <div className="column w64 g1">
        <h2>What's Included</h2>
        <p className="ctext">
          For $250, we'll walk you through the process of registering your
          business, start to finish.
        </p>
        <div className="columns g1">
          <div className="column">
            <strong className="title">
              State and Federal Business Registration
            </strong>
            <div className="column background_white shadow">
              <Service>
                <p>FEIN registration</p>
              </Service>
              <Service>
                <p>State business registration</p>
              </Service>
              <Service>
                <p>Articles of Organization filing</p>
              </Service>
              <Service>
                <p>City business registration assitance</p>
              </Service>
            </div>
          </div>
          <div className="column">
            <strong className="title">Tax Account Registration</strong>
            <div className="column background_white shadow">
              <Service>
                <p>State unemployment account</p>
              </Service>
              <Service>
                <p>State withholding account</p>
              </Service>
              <Service>
                <p>Sales and use tax (if applicable)</p>
              </Service>
              <Service>
                <p>Utah TAP account setup</p>
              </Service>
            </div>
          </div>
        </div>
        <div className="column">
          <strong className="title">Accounting Software Setup</strong>
          <div className="columns background_white shadow">
            <div className="column">
              <Service>
                <p>Create and maintain an account</p>
              </Service>
              <Service>
                <p>Set up payments</p>
              </Service>
            </div>
            <div className="column">
              <Service>
                <p>Link bank feeds</p>
              </Service>
              <Service>
                <p>Your questions answered</p>
              </Service>
            </div>
          </div>
        </div>
        <a
          className="cta"
          href="https://calendar.app.google/cgho9MaUp1oADCZLA"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get started
        </a>
      </div>
    </div>
  );
};

export default Included;
